<template>
  <div class="arches-cloud fill-height ubuntu">
    <v-app-bar app clipped-left color="#f0faff">
      <v-app-bar-nav-icon @click="drawerModel = !drawerModel">
        <v-icon> mdi-menu </v-icon>
      </v-app-bar-nav-icon>
      <v-toolbar-title>
        <v-img
          contain
          max-height="48"
          :src="
            $vuetify.breakpoint.xs
              ? require('../assets/logo.png')
              : require('../assets/logo_text_right.png')
          "
        />
      </v-toolbar-title>
      <v-tooltip bottom>
        <template #activator="{ on }">
          <v-app-bar-nav-icon class="ml-auto" v-on="on" @click="$router.push('/')">
            <v-icon> mdi-home </v-icon>
          </v-app-bar-nav-icon>
        </template>
        Return to portal
      </v-tooltip>
    </v-app-bar>
    <v-navigation-drawer v-model="drawerModel" color="#f0faff" clipped app>
      <v-list>
        <v-list-item
          v-for="level in levels"
          :to="`/cloud/${level.uuid}/`"
          :key="level.uuid"
          @click="$store.commit('cloud/setName', level.name)"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ level.name }}
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <v-icon> mdi-folder </v-icon>
          </v-list-item-action>
        </v-list-item>
        <CloudListItem
          v-for="folder in folders"
          :key="folder.uuid"
          :address="folder"
          @delete-address="onDelete"
        />
        <v-list-item v-if="['ADMIN', 'ASSISTANT'].includes($store.state.profile.role)">
          <CreateFolder
            :extraBody="{ level: null, folder: null }"
            @new-folder="folders.push($event)"
          >
            <template #activator="{ on }">
              <v-btn outlined block color="pink" class="white--text" v-on="on">
                Create Folder
                <v-icon right> mdi-folder-plus </v-icon>
              </v-btn>
            </template>
          </CreateFolder>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-main class="fill-height arches-cloud">
      <div class="display-1 text-center my-10" v-if="!level">Select a folder</div>

      <router-view />
    </v-main>
  </div>
</template>
<script>
import { getLevels, getFolderData } from "@/api/api";
import CreateFolder from "./Cloud/CreateFolder.vue";
import CloudListItem from "./Cloud/CloudListItem.vue";
export default {
  components: { CreateFolder, CloudListItem },
  data() {
    return {
      levels: [],
      folders: [],

      loadingFolders: false,
      loadingLevels: false,
      drawerModel: true,
    };
  },
  computed: {
    level() {
      return this.$route.params.level__uuid;
    },
  },
  methods: {
    onDelete(uuid) {
      const index = this.folders.findIndex((i) => i.uuid === uuid);
      if (index > -1) this.folders.splice(index, 1);
    },
  },
  async mounted() {
    try {
      this.loadingFolders = true;
      getFolderData(null, null).then((response) => {
        this.folders = response.data;
        this.loadingFolders = false;
      });
      this.loadingLevels = true;
      const response = await getLevels();
      this.levels = response.data;
    } finally {
      this.loadingLevels = false;
    }
  },
};
</script>

<style scoped>
.arches-cloud {
  background-color: #fff !important;
}
</style>
